import endpoint from "../../config/endpoints";

export const AdditionalActivityJson = {
  showSaveNextBtn: true,
  formPath: "/additional-activity-form",
  apiBaseURL: endpoint.additionalActivity,
  changeExcel: endpoint.exportData,
  screenTitle: "Additional Activity",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "Additional Activity",
  showExcelDownload: false,
  excelFileName: "Additional Activity",
  formPathView: "/additional-activity-view",
  isActiveURL: endpoint.additionalActivity + "/update-is-active-status",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Name",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Description",
      columnKeyName: "description",
      isChecked: true,
    },
    {
      columnDisplayName: "Beat Type",
      columnKeyName: "beatType",
      isChecked: true,
    },
    {
      columnDisplayName: "Start Action",
      columnKeyName: "startAction",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "isActive",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "name",
      isMandatory: true,
      uniqueValidation: true,
    },
    {
      label: "Description",
      controlType: "textfield",
      placeHolder: "Description",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "description",
      isMandatory: true,
    },

    {
      label: "Beat Type",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "beatType",
      tableDataKey: "beatType",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Working",
          value: "0",
        },
        {
          label: "Non-Working",
          value: "1",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Start Action",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "startAction",
      tableDataKey: "startAction",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Yes",
          value: "1",
        },
        {
          label: "No",
          value: "0",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "multiSelect",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockStakeHolderTypeIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Other Task Type",
      controlType: "multiSelect",
      placeHolder: "Select Other Task Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "otherTaskTypeDetail",
      dataKey: "otherWorkTaskIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
};
